import React from "react";
import AppleWalletBadge from "./AppleWalletBadge";
import "./WalletLastStep.css";
import { t } from "../i18n";

// The full-screen Apple Wallet step (founder, 1.5.1 #9, "A + B"): a new
// talent lands here once, right after the Face ID + notification asks
// (lib/walletMoment → DJQrPage ?wallet=1). Their own pass slides in — our
// artwork, so it may move; Apple's button stays still. "Later" drops them on
// the QR page with a ring + tip around the same button.
const WalletLastStep: React.FC<{ passUrl: string | null; busy: boolean; onAdd: () => void; onLater: () => void }> = ({ passUrl, busy, onAdd, onLater }) => (
  <div className="wls" role="dialog" aria-modal="true" aria-label={t("walletStep.title")}>
    <div className="wls-inner">
      <div className="wls-pass">{passUrl ? <img src={passUrl} alt="" /> : <span className="wls-pass-ph" />}</div>
      <h2 className="wls-title">{t("walletStep.title")}</h2>
      <div className="wls-badge">
        <AppleWalletBadge onClick={onAdd} busy={busy} />
      </div>
      <button type="button" className="wls-later" onClick={onLater}>
        {t("walletStep.later")}
      </button>
    </div>
  </div>
);

export default WalletLastStep;
